import { FC } from 'react';
import { useAppSelector } from '../../../hooks/store.hooks';
import InitMiddlewareAddCategory from '../middlewares/InitMiddleware';
import AddProductProvider from '../memory/memr';

const EditCategoryInstance: FC<{}> = () => {
  return (
    <AddProductProvider>
      <InitMiddlewareAddCategory />
    </AddProductProvider>
  );
};

export default EditCategoryInstance;
